import { func, number } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import withConfirm from '../../../../generic/with-confirm';
import { COLORS } from '../../../../utils/constants';
import { allStatusesEnum as invoiceStatuses } from '../../../constants';

const ButtonWithConfirmation = withConfirm(
  'Do you really want to move this invoice back to Draft?',
)(Button);

export default function MoveBackToDraft({ onUpdateStatus, id, ...rest }) {
  return (
    <ButtonWithConfirmation
      onClick={() => onUpdateStatus(id, invoiceStatuses.DRAFT.value)}
      color={COLORS.WARNING}
      {...rest}
    >
      Move back to Draft
    </ButtonWithConfirmation>
  );
}

MoveBackToDraft.propTypes = {
  onUpdateStatus: func.isRequired,
  id: number.isRequired,
};
